import React from 'react';
import {Bus, Clock, Phone, Train} from 'lucide-react';

const ContactAndTransportation = () => {
    return (
        <div className="container">
            <div className="flex flex-col md:flex-row w-full bg-gray-50 overflow-hidden  ">
                {/* Left Section - Contact Details */}
                <div className="w-full  p-8 ">
                    <h2 className="text-gray-700 text-sm uppercase tracking-wide mb-2">NOUS CONTACTER</h2>
                    <h1 className="text-2xl font-bold text-blue-900 mb-6 border-b pb-2">Coordonnées</h1>

                    <p className="text-gray-600 mb-6 text-justify hyphens-auto">
                        <span className="whitespace-nowrap">Vous avez des questions</span> ou besoin d'aide pour <span className="whitespace-nowrap">vos procédures&nbsp;?</span> N'hésitez pas à nous contacter.

                    </p>
                    <div className="mb-6">
                        <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                            <Clock className="h-4 w-4 mr-2 our-red-text"/>
                            Horaires d'ouverture
                        </h3>
                        <p className="text-gray-700">Lundi - Vendredi : 9h30 à 18h30</p>
                        <p className="text-gray-700">Samedi : 10h à 17h</p>
                    </div>

                    <div className="mb-6">
                        <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                            <Phone className="h-4 w-4 mr-2 our-red-text"/>
                            Appelez-nous
                        </h3>
                        <p className="text-gray-700">+33 1 89 71 59 61</p>
                    </div>

                    <div className="mb-6">
                        <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 our-red-text" width="24"
                                 height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                 strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            Adresse
                        </h3>
                        <p className="text-gray-700">47 Av. du Docteur Arnold Netter<br/>75012 Paris</p>
                    </div>
                </div>

                {/* Right Section - Transportation */}
                <div className="w-full  p-8 ">
                    <h2 className="text-gray-700 text-sm uppercase tracking-wide mb-2">NOUS TROUVER</h2>
                    <h1 className="text-2xl font-bold text-blue-900 mb-6 border-b pb-2">Transports en commun</h1>

                    <div className="space-y-6">
                        <div className="flex items-start">
                            <div
                                className="h-10 w-10 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0 mr-4">
                                <Train className="h-5 w-5 text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-800 mb-1">RER A</h3>
                                <p className="text-gray-600">Nation - à 1,2 km à pied</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <div
                                className="h-10 w-10 rounded-full bg-yellow-500 flex items-center justify-center flex-shrink-0 mr-4">
                                <Train className="h-5 w-5 text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-800 mb-1">Métro ligne 1</h3>
                                <p className="text-gray-600">Portes de Vincennes - à 750 mètres</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <div
                                className="h-10 w-10 rounded-full bg-green-600 flex items-center justify-center flex-shrink-0 mr-4">
                                <Train className="h-5 w-5 text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-800 mb-1">Métro ligne 6</h3>
                                <p className="text-gray-600">Picpus - à 300 mètres</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <div
                                className="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mr-4">
                                <Bus className="h-5 w-5 text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-800 mb-1">Bus 29</h3>
                                <p className="text-gray-600">Arrêt : Docteur Netter</p>
                            </div>
                        </div>

                        <div className="flex items-start">
                            <div
                                className="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mr-4">
                                <Bus className="h-5 w-5 text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-800 mb-1">Bus 64</h3>
                                <p className="text-gray-600">Arrêt : Avenue de Saint-Mandé</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ContactAndTransportation;

